import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { firestore, auth } from '../firebase'; // Ensure both firestore and auth are imported
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

const StudentDetailsScreen = () => {
  const { state } = useLocation(); // Access the passed state
  const { data } = state || {}; // Destructure the data from state
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  if (!data) {
    return <p style={{ color: 'red', fontSize: '16px', textAlign: 'center', marginTop: '20px' }}>No data available</p>;
  }

  // Function to create a Firebase user and save data to Firestore
  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      alert('Error: Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      // Create a Firebase Authentication user
      const userCredential = await createUserWithEmailAndPassword(auth, data.EmailAddress, password);
      const userId = userCredential.user.uid;

      // Save the student data in Firestore under the userId
      await setDoc(doc(firestore, 'students', userId), {
        FirstName: data.FirstName,
        MiddleName: data.MiddleName,
        Surname: data.Surname,
        EmailAddress: data.EmailAddress,
        PhoneNumber: data.PhoneNumber,
        StudentID: data.StudentID,
      });
      setLoading(false);
      alert('Account activated successfully!');
      navigate('/'); // Navigate to login screen after saving
    } catch (error) {
      setLoading(false);
      alert('Failed to activate account. Please try again.');
      console.error(error);
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#ffffff' }}>
      {/* Student Image */}
      <img
        src={require('../cosmologo.png')}
        alt="Student"
        style={{ width: '120px', height: '120px', borderRadius: '60px', display: 'block', margin: '0 auto 20px' }}
      />
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', textAlign: 'center', marginBottom: '20px' }}>
        Student Details
      </h2>

      {loading ? <div style={{ textAlign: 'center' }}>Loading...</div> : null}

      {/* Student Information */}
      <div style={{
        backgroundColor: '#f2f6ff',
        borderRadius: '10px',
        padding: '15px',
        marginBottom: '20px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      }}>
        <p style={{ fontSize: '16px', color: '#1f2937', marginBottom: '5px' }}>Student ID: {data.StudentID}</p>
        <p style={{ fontSize: '16px', color: '#1f2937', marginBottom: '5px' }}>Name: {data.FirstName} {data.MiddleName} {data.Surname}</p>
        <p style={{ fontSize: '16px', color: '#1f2937', marginBottom: '5px' }}>Email: {data.EmailAddress}</p>
        <p style={{ fontSize: '16px', color: '#1f2937', marginBottom: '5px' }}>Phone Number: {data.PhoneNumber}</p>
      </div>

      {/* Password Fields */}
      <input
        type="password"
        placeholder="Password"
        style={{
          backgroundColor: '#ffffff',
          padding: '15px',
          borderRadius: '10px',
          marginBottom: '15px',
          fontSize: '16px',
          color: '#1f2937',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          width: '98%',
        }}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        type="password"
        placeholder="Confirm Password"
        style={{
          backgroundColor: '#ffffff',
          padding: '15px',
          borderRadius: '10px',
          marginBottom: '15px',
          fontSize: '16px',
          color: '#1f2937',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          width: '98%',
        }}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      {/* Submit Button */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
  <button
    style={{
      backgroundColor: '#013a64',
      padding: '15px 20px',
      width: '20px',
      borderRadius: '10px',
      color: '#fff',
      fontSize: '18px',
      fontWeight: 'bold',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 10px 20px rgba(0, 0, 255, 0.3)',
      width: '50%',
    }}
    onClick={handleSubmit}
  >
    Submit
  </button>

  <button 
    onClick={() => navigate(-1)} 
    style={{
      backgroundColor: '#013a64',
      padding: '15px 20px',
      borderRadius: '10px',
      color: '#fff',
      fontSize: '18px',
      fontWeight: 'bold',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 10px 20px rgba(0, 0, 255, 0.3)',
      width: '50%',
    }}
  >
    Back
  </button>
</div>

    </div>
  );
};

export default StudentDetailsScreen;
